import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BookingTransfersState = {
  value: BookingDetails['transfers'] | null;
};

const initialState: BookingTransfersState = {
  value: null,
};

function setBookingTransfersFunction(
  state: BookingTransfersState,
  action: PayloadAction<BookingTransfersState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingTransfers',
  initialState,
  reducers: {
    setBookingTransfers: setBookingTransfersFunction,
    resetState: resetStateFunction,
  },
});

export const { setBookingTransfers, resetState } = slice.actions;
export default slice.reducer;
